import { abortIfNotPermitted } from '../utils';

export default [
    {
        path: '/',
        component: () =>
            import(/* webpackChunkName: "myaccount" */ '@js/franchise_component/my-account/my-account.vue'),
        beforeEnter: (to, from, next) => {
            return abortIfNotPermitted('franchise_view_account', next);
        },
    },
    {
        path: '/franchise',
        component: () =>
            import(/* webpackChunkName: "myaccount" */ '@js/franchise_component/my-account/my-account-update-franchise.vue'),
        beforeEnter: (to, from, next) => {
            return abortIfNotPermitted('franchise_manage_account', next);
        },
    },
];
